/*
 * @Author: liuyongjun
 * @Date: 2023-02-07 09:47:12
 * @LastEditors: bianbinbin
 * @LastEditTime: 2024-04-18 14:42:17
 * @PageTitle: 页面...
 * @Description: 描述...
 * @FilePath: /ejx-web/src/i18n/langs/en.js
 */
export default {
  en: {
    message: {
      hello: 'hello world',
      FlightDynamics: 'flight dynamics'
    },
    crewMeal: {
      title: 'Crew Meal Selection',
      choosedate: 'Please select a date',
      choose: 'Please select',
      confirm: 'Confirm',
      cancel: 'Cancel',
      submit: 'Submit',
      complete: 'Complete',
      ground: 'Ground',
      board: 'On Board',
      isSubmit: 'Confirm submission ?',
      success: 'Submit Successfully',
      fail: 'Submit Failure',
      chooseMeal: 'Choose Meal'
    },
    common: {
      nodata: 'No Data'
    }
  }
}
